"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import CarrierName from "../carrier_name";
import CarrierTypeAhead from "../carrier_typeahead";
import ReactUtils from "../../react_utils";
const bem = ReactUtils.makeBem("carrier-chooser");
export default React.createClass({
  statics: {
    initialState: function() {
      return {
        selectedIndex: 0,
        typeAheadCarrier: null
      };
    },
    selectedCarrierID: function(state, carrierGuesses) {
      if (state.selectedIndex == null) {
        return null;
      } else if (state.selectedIndex < carrierGuesses.length) {
        return carrierGuesses[state.selectedIndex].carrierID;
      } else if (state.typeAheadCarrier) {
        return state.typeAheadCarrier.id;
      }
    },
    assignCustomerOnlyDocuments: function(state) {
      if (state.selectedIndex == null) {
        return true;
      } else {
        return false;
      }
    }
  },
  onSelectionChange: function(index) {
    this.props.onUpdate(
      _.extend(_.clone(this.props.state), { selectedIndex: index })
    );
  },
  onNoCarrierSelectionChange: function() {
    this.props.onUpdate({
      typeAheadCarrier: null,
      selectedIndex: null
    });
  },
  typeAheadCarrierSelected: function(carrier) {
    this.props.onUpdate({
      typeAheadCarrier: carrier,
      selectedIndex: this.props.carrierGuesses.length
    });
  },
  typeAheadCarrierCleared: function() {
    this.props.onUpdate(__spreadProps(__spreadValues({}, this.props.state), {
      typeAheadCarrier: null
    }));
  },
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { className: bem() }, _.map(this.props.carrierGuesses, this.guessedCarrier), /* @__PURE__ */ React.createElement("div", { className: bem("__choice") }, /* @__PURE__ */ React.createElement(
      "input",
      {
        className: bem("__typeahead-radio") + " mousetrap",
        name: "carrier",
        checked: this.props.state.selectedIndex === this.props.carrierGuesses.length,
        onChange: _.partial(this.onSelectionChange, this.props.carrierGuesses.length),
        type: "radio"
      }
    ), /* @__PURE__ */ React.createElement("div", { className: bem("__typeahead") }, /* @__PURE__ */ React.createElement(
      CarrierTypeAhead,
      {
        onSelectCarrier: this.typeAheadCarrierSelected,
        onClearCarrier: this.typeAheadCarrierCleared,
        onFocus: _.partial(
          this.onSelectionChange,
          this.props.carrierGuesses.length
        ),
        carrier: this.props.state.typeAheadCarrier
      }
    ))), this.indexCustomerOnlyDocuments());
  },
  guessedCarrier: function(guess, index) {
    return /* @__PURE__ */ React.createElement("div", { className: bem("__choice"), key: `guess_${guess.carrierID}` }, /* @__PURE__ */ React.createElement(
      "input",
      {
        className: bem("__guessed-radio") + " mousetrap",
        name: "carrier",
        onChange: _.partial(this.onSelectionChange, index),
        checked: this.props.state.selectedIndex === index,
        type: "radio"
      }
    ), /* @__PURE__ */ React.createElement("div", { className: bem("__guessed-carrier") }, /* @__PURE__ */ React.createElement(CarrierName, { carrierID: guess.carrierID }), " (", guess.context, ")"));
  },
  indexCustomerOnlyDocuments: function() {
    if (this.props.allowIndexingCustomerOnlyDocuments) {
      return /* @__PURE__ */ React.createElement("div", { className: bem("__choice") }, /* @__PURE__ */ React.createElement(
        "input",
        {
          className: bem("__guessed-radio") + " mousetrap",
          name: "carrier",
          checked: this.props.state.selectedIndex === null,
          onChange: _.partial(this.onNoCarrierSelectionChange),
          type: "radio"
        }
      ), /* @__PURE__ */ React.createElement("div", { className: bem("__guessed-carrier") }, /* @__PURE__ */ React.createElement("p", null, "Assign documents to load without assigning a carrier")));
    }
  }
});
